export default "__VITE_ASSET__rF6RFnDg__"